import React, { Component } from 'react';
import swal from 'sweetalert';
import {baseUrl} from '../../Comman/apiEndPoints';
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class AlarmSoundComponent extends Component {
    constructor(props){
        super(props)
        this.state = {
            abortSound : null,
            updateSound : null,
            normalSound : null,
            emergencySound : null,
            compressionSound : null,
            alarmSound:null,
            rowIndex : null,
            isEditable : false,
            soundName : ''
        }
        this._handleAudioChange = this._handleAudioChange.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        const { t } = this.props;
        console.log("next", nextProps);
        if (nextProps.alarmSoundData.message != this.props.alarmSoundData.message) {
            if (nextProps.alarmSoundData.statusCode == 200) {
                swal(`${t('Alarm Setting.Audio file Updated')}`, {
                    icon: "success",
                });
                this.props.getAllSoundData();
                this.setState({ 
                    rowIndex : null, 
                    isEditable : false,
                    compressionSound : null,
                    abortSound : null,
                    updateSound : null,
                    normalSound : null,
                    emergencySound : null,
                    alarmSound:null,
                    soundName : ''
                })
            }
        }
    }
    _handleAudioChange(e) {
        const { t } = this.props;
        e.preventDefault();
        if(e.target.files[0]!==undefined){
            // let reader = new FileReader();
            const urlObj = URL.createObjectURL(e.target.files[0]);
            const audio = document.getElementById("alarm-sound");
            audio.addEventListener("load", () => {
                URL.revokeObjectURL(urlObj);
              });
              audio.controls = "true";
              audio.src = urlObj;
            let file = e.target.files[0];
            var fileInput = document.getElementById('alarmSoundFile');
            console.log(file)
            var filePath = e.target.value;
            var allowedExtensions = /(\.mp3|\.wav|\.wma|\.aac)$/i;
            if(!allowedExtensions.exec(filePath)){
                swal(`${t('Alarm Setting.Please upload file having extensions')}`);
                fileInput.value = '';
                return false;
            }
            else if(file.size>1000000){
                swal(`${t('Alarm Setting.Please upload file less than 1 MB')}`);
                fileInput.value = '';
                return false;
            }
            else{
                if(this.state.soundName == "NewAlarmSound"){
                    this.setState({
                        alarmSound : file,
                        compressionSound : null,
                        abortSound : null,
                        updateSound : null,
                        normalSound : null,
                        emergencySound : null,
                    })
                }
                else if(this.state.soundName == "CompressionAudio"){
                    this.setState({
                        alarmSound : null,
                        compressionSound : file,
                        abortSound : null,
                        updateSound : null,
                        normalSound : null,
                        emergencySound : null,
                    })
                }   
                else if(this.state.soundName == "AbortSound"){
                    this.setState({
                        alarmSound : null,
                        abortSound : file,
                        compressionSound : null,
                        updateSound : null,
                        normalSound : null,
                        emergencySound : null,
                    })
                }
                else if(this.state.soundName == "UpdateAlarmSound"){
                    this.setState({
                        alarmSound : null,
                        abortSound : null,
                        compressionSound : null,
                        updateSound : file,
                        normalSound : null,
                        emergencySound : null,
                    })
                }
                else if(this.state.soundName == "NormalNotification"){
                    this.setState({
                        alarmSound : null,
                        abortSound : null,
                        compressionSound : null,
                        updateSound : null,
                        normalSound : file,
                        emergencySound : null,
                    })
                }
                else if(this.state.soundName == "EmergencyNotification"){
                    this.setState({
                        alarmSound : null,
                        abortSound : null,
                        compressionSound : null,
                        updateSound : null,
                        normalSound : null,
                        emergencySound : file,
                    })
                }
                sleep(3000).then(() => {
                    console.log("setstate",this.state);
                })
            }
        }
    }
    // editAlarmSound = () =>{
    //     if(this.state.alarmSound){
    //         const formData = new FormData();
    //         formData.append('SettingValue',this.state.alarmSound)
    //         this.props.updateAlarmSound(formData);
    //     }
    //     else{
    //         swal('Please upload file');
    //     }
    // }
    edit = (data) => {
        console.log("item", data);
        this.setState({ 
            rowIndex : data.index, 
            isEditable : true,
            soundName : data.SettingName
        })       
    }
    save = () => {
        const { t } = this.props;
        if(this.state.soundName == "NewAlarmSound" && this.state.alarmSound){
            const formData = new FormData();
            formData.append('SettingValue',this.state.alarmSound)
            this.props.updateAlarmSound(formData);
        }
        else if(this.state.soundName == "CompressionAudio" && this.state.compressionSound){
            const formData1 = new FormData();
            formData1.append('SettingValue',this.state.compressionSound)
            this.props.updateCompressionSound(formData1);
        }
        else if(this.state.soundName == "AbortSound" && this.state.abortSound){
            const formData1 = new FormData();
            formData1.append('SettingValue',this.state.abortSound)
            this.props.updateAbortSound(formData1);
        }
        else if(this.state.soundName == "UpdateAlarmSound" && this.state.updateSound){
            const formData1 = new FormData();
            formData1.append('SettingValue',this.state.updateSound)
            this.props.updateSound(formData1);
        }
        else if(this.state.soundName == "NormalNotification" && this.state.normalSound){
            const formData1 = new FormData();
            formData1.append('NotificationSound',this.state.normalSound)
            this.props.updateNormalSound(formData1);
        }
        else if(this.state.soundName == "EmergencyNotification" && this.state.emergencySound){
            const formData1 = new FormData();
            formData1.append('NotificationSound',this.state.emergencySound)
            this.props.updateEmergencySound(formData1);
        }
        else{
                    swal(`${t('Alarm Setting.Please upload file')}`);
                }
    }
    cancel = () => {
        this.setState({ 
            rowIndex: null,
            isEditable : false,
            compressionSound : null,
            alarmSound:null,
            abortSound : null,
            updateSound : null,
            normalSound : null,
            emergencySound : null,
            soundName : ''
        })
    }
    render(){
        const { t } = this.props;
        console.log("sdsad",this.props.alarmSoundData);
        return(
            <div className="container">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Alarm Setting.Alarm Sound Setting')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className="setting-data">
                        <div className="row">
                        {
                            (this.props.alarmSoundData.isLoading && this.state.isEditable == false) ?
                            <img src={loader} width="30" alt="" style={{margin:'auto', display:'block'}} /> : ''
                        }
                            <div className="col-md-12 alarm-sound-css">
                            {
                            (this.props.alarmSoundData && this.props.alarmSoundData.alarmSoundList.length > 0) ?
                            this.props.alarmSoundData.alarmSoundList.map((item, index) =>
                                <div key={index} id={index} className="row">
                                    <div className="col-md-2">
                                        <div className="displaynone">{item.index = index}</div>
                                        <p className="displaynone">{item.isEdit = false}</p>
                                        <p>{item.DisplayName}</p>
                                    </div>
                                    <div className="col-md-7">
                                        { (this.state.rowIndex == item.index) ?
                                            <div>
                                                <audio id="alarm-sound" controls></audio>
                                                <input type="file" onChange={this._handleAudioChange} id="alarmSoundFile" className="hide_input_type_file" />
                                                <label for="alarmSoundFile" className="choose-file-btn">{t('Feedback Setting.Select')}</label>
                                            </div>
                                             :
                                            <audio src={baseUrl + item.SettingValue + '?noCache=' + Math.floor(Math.random() * 1000000)} controls></audio>
                                        }
                                    </div>
                                    <div className="col-md-3">
                                        {
                                            this.state.rowIndex == item.index ?
                                                <div>
                                                    {
                                                        this.props.alarmSoundData.isLoading ?
                                                        <img src={loader} width="30" alt="" /> : ''
                                                    }
                                                    <button type="button" className="btn btn-primary mar-right-15" 
                                                        disabled={this.props.alarmSoundData.isLoading == true}
                                                        onClick={this.save}>{t('Alarm Setting.Save')}</button>
                                                    <button type="button" className="btn btn-primary"
                                                        disabled={this.props.alarmSoundData.isLoading == true}
                                                        onClick={this.cancel}>{t('Alarm Setting.Cancel')}</button>
                                                </div> :
                                                <button type="button" onClick={this.edit.bind(this, item)}
                                                    className={this.state.isEditable == item.isEdit ? 'btn btn-primary' : 'btn btn-primary not-show-btn' }
                                                >{t('Alarm Setting.Edit')}</button>
                                        }
                                    </div>
                                </div>
                            )
                        : <p>{t('Alarm Setting.No alarm sound and compression sound')}</p> }
                                {/* Alarm Sound
                                <input type="file" onChange={this._handleAudioChange} id="alarmSoundFile"/>
                                <audio id="alarm-sound" controls></audio>
                                <button type="button" className="btn btn-primary"
                                    onClick={this.editAlarmSound}>Edit</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withNamespaces()(AlarmSoundComponent);